import { DATE_FORMAT_WITH_HOUR_MINS, displayDate } from 'utils/date';

import { InAppDestination, InAppTriggerDefinition } from 'modules/graphql';
import moment from 'moment';
import { useTemplateContext } from '../../../context';
import { InAppPrimaryContent } from '../../../types';

import { LightText } from '../Sections.styled';
import { CampaignFormField, ReadOnlyField } from '../../FormFields';

const getExpirationTime = (inAppData: any) => {
  if (inAppData.expirationDateTime) {
    return displayDate(moment(inAppData.expirationDateTime), DATE_FORMAT_WITH_HOUR_MINS);
  } else if (inAppData.expirationDuration) {
    return `send time ${inAppData.expirationDuration.replace(/now/g, '')}`;
  } else {
    return 'send time +90d';
  }
};

export const InAppSendingInformation = () => {
  const { templateAndContent } = useTemplateContext();
  const { primaryContent } = templateAndContent;

  const inAppDataPrimaryContent = (primaryContent as InAppPrimaryContent) || {};

  const isRokuApp = inAppDataPrimaryContent?.destinations?.includes(InAppDestination.Roku);

  if (isRokuApp) {
    return null;
  }

  const { trigger } = inAppDataPrimaryContent;
  const { saveToInbox } = inAppDataPrimaryContent;
  const isDeliverSilently = trigger === InAppTriggerDefinition.Never;

  return (
    <>
      <CampaignFormField labelText="Expiration time">
        <ReadOnlyField name="expirationTime">
          {getExpirationTime(inAppDataPrimaryContent)}
        </ReadOnlyField>
      </CampaignFormField>
      <CampaignFormField labelText="Show in mobile inbox">
        <ReadOnlyField name="mobileInbox">
          {saveToInbox ? 'On' : <LightText>Off</LightText>}
        </ReadOnlyField>
      </CampaignFormField>
      <CampaignFormField labelText="Deliver silently">
        <ReadOnlyField name="deliverSilently">
          {isDeliverSilently ? 'On' : <LightText>Off</LightText>}
        </ReadOnlyField>
      </CampaignFormField>
    </>
  );
};
